// extracted by mini-css-extract-plugin
export var chatIcon = "feedback-form-preview-module--chatIcon--71230";
export var feedbackBanner = "feedback-form-preview-module--feedbackBanner--da85e";